export const SAVE_DASHBOARD_DATA = 'dashboard/SAVE_DASHBOARD_DATA';
export const UPDATE_AGENCY_PAUSED = 'dashboard/UPDATE_AGENCY_PAUSED';
